import * as React from 'react';

import Tabs from 'antd/es/tabs';

import Loader from '@common/react/components/Core/LoaderProvider/Loader';
import { ItemsProvider, useItemsProviderContext } from '@common/react/components/Core/ItemsProvider/ItemsProvider';

import { CardBlock } from '@app/components/Pages/Register/CardBlock';
import { CardImageType } from '@app/objects/CardImageType';
import { Insurance, InsurancePriority } from '@app/objects/Insurance';

interface ComponentProps {
	cardPanelClassName?: string;
	onTabChange?: (key: string) => void;
	showOnlyPrimary?: boolean;
}

interface InsuranceCardsWrapperProps extends ComponentProps {
	initialItems?: Array<Insurance>;
}

export const InsuranceCards: React.FC<ComponentProps> = (props) => {
	const { state: { items, loading } } = useItemsProviderContext<Insurance>();

	const primary: Insurance | undefined = items.find((ins) => ins.insurancePriority === InsurancePriority.Primary);
	const secondary: Insurance | undefined = items.find((ins) => ins.insurancePriority === InsurancePriority.Secondary);
	const tabs = [
		{
			key: 'primary',
			label: 'Primary',
			children: <div className={`row card-panel${props.cardPanelClassName && ` ${props.cardPanelClassName}`}`}>
				{loading ? <Loader />
					: <>
						<CardBlock
							objectId={primary ? primary.id : -1}
							fileType="insurance"
							cardType={CardImageType.Front}
							defaultScr={primary ? primary.photoFront : ''}
						/>
						<CardBlock
							objectId={primary ? primary.id : -1}
							fileType="insurance"
							cardType={CardImageType.Back}
							defaultScr={primary ? primary.photoBack : ''}
						/>
					</>}
			</div>,
		},
		{
			key: 'Secondary',
			label: 'Secondary',
			children: <div className={`row card-panel${props.cardPanelClassName && ` ${props.cardPanelClassName}`}`}>
				{loading ? <Loader />
					: <>
						<CardBlock
							objectId={secondary ? secondary.id : -1}
							fileType="insurance"
							cardType={CardImageType.Front}
							defaultScr={secondary ? secondary.photoFront : ''}
						/>
						<CardBlock
							objectId={secondary ? secondary.id : -1}
							fileType="insurance"
							cardType={CardImageType.Back}
							defaultScr={secondary ? secondary.photoBack : ''}
						/>
					</>
				}
			</div>,
		},
	];

	if (props.showOnlyPrimary) {
		return tabs[0].children;
	}

	return <>
		<Tabs
			type="card"
			onChange={props.onTabChange}
			items={[
				{
					key: 'primary',
					label: 'Primary',
					children: <div className={`row card-panel${props.cardPanelClassName && ` ${props.cardPanelClassName}`}`}>
						{loading ? <Loader />
							: <>
								<CardBlock
									objectId={primary ? primary.id : -1}
									fileType="insurance"
									cardType={CardImageType.Front}
									defaultScr={primary ? primary.photoFront : ''}
								/>
								<CardBlock
									objectId={primary ? primary.id : -1}
									fileType="insurance"
									cardType={CardImageType.Back}
									defaultScr={primary ? primary.photoBack : ''}
								/>
							</>}
					</div>,
				},
				{
					key: 'Secondary',
					label: 'Secondary',
					children: <div className={`row card-panel${props.cardPanelClassName && ` ${props.cardPanelClassName}`}`}>
						{loading ? <Loader />
							: <>
								<CardBlock
									objectId={secondary ? secondary.id : -1}
									fileType="insurance"
									cardType={CardImageType.Front}
									defaultScr={secondary ? secondary.photoFront : ''}
								/>
								<CardBlock
									objectId={secondary ? secondary.id : -1}
									fileType="insurance"
									cardType={CardImageType.Back}
									defaultScr={secondary ? secondary.photoBack : ''}
								/>
							</>
						}
					</div>,
				},
			]}
		/>
	</>;
};

const InsuranceCardsWrapper: React.FC<InsuranceCardsWrapperProps> = (props) => {
	return (
		<ItemsProvider<Insurance>
			loadRequest="insurancePageViewList"
			items={props.initialItems}
		>
			<InsuranceCards {...props} />
		</ItemsProvider>
	);
};

export default InsuranceCardsWrapper;
